import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form } from 'redux-form/immutable';
import { fromJS } from 'immutable';

import {
  TextField,
  SelectField,
} from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import { Tabs, Tab } from 'material-ui/Tabs';
import Chip from 'material-ui/Chip';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import _ from 'lodash';

import {
  setCustomer,
  fetchCustomer,
  setLogo,
  addContact,
  removeContact,
  addAddress,
  removeAddress,
  addTag,
  removeTag,
} from '../../actions/customers';
import ContactsTable from '../ContactsTable/index';
import AddressesTable from '../AddressesTable/index';
import ImageUpload from '../Common/ImageUpload';
import ReduxDialog from '../Common/ReduxDialog';
import { toJSSafe, toArray, id } from '../../utils/helper';
import { hasPermission } from '../../utils/authenticated';

import { saveCustomerRoutine } from '../../routines';

import FireBaseTools, { firebaseStorage, getTenantPath } from '../../utils/firebase';

import { fetchEmployees } from '../../actions/employees';
import { showDialog, hideDialog, showError } from '../../actions/dialogs';

import commonStyles from '../styles';
import styles from './styles';

const validate = (values, props) => {
  const errors = {};
  // TODO implement valdiation
  // const requiredFields = ['firstName', 'lastName', 'mobile'];
  // requiredFields.forEach((field) => {
  //   if (!valuesObj[field]) {
  //     errors[field] = `Require a ${splitCamelCase(field)} field`;
  //   }
  // });
  //
  // if ((valuesObj.firstName && valuesObj.lastName) || valuesObj.email) {
  //   props.employees.forEach((employee) => {
  //     // if ((employee.firstName.toLowerCase() === valuesObj.firstName.toLowerCase() &&
  //     // employee.lastName.toLowerCase() === valuesObj.lastName.toLowerCase())) {
  //     //   errors.firstName = 'User already exist';
  //     //   errors.lastName = 'User already exist';
  //     // }
  //     if (employee.id !== valuesObj.id && employee.email === valuesObj.email) {
  //       errors.email = 'Email already exist';
  //     }
  //   });
  // }
  // if (valuesObj.mobile && !validateMobile(valuesObj.mobile)) {
  //   errors.mobile = 'Only Numeric Characters';
  // }
  // if (valuesObj.email && !validateEmail(valuesObj.email)) {
  //   errors.email = 'Invalid email address';
  // }
  return errors;
};

const handleRequestClose = (props, customer) => {
  if (props.onRequestClose) {
    props.onRequestClose(customer);
  } else {
    props.hideDialog('customer');
  }
};

class Customer extends Component {
  static propTypes = {
    fetchCustomer: PropTypes.func.isRequired,
    fetchEmployees: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    employees: PropTypes.array.isRequired,

    setCustomer: PropTypes.func.isRequired,
    setLogo: PropTypes.func.isRequired,

    addAddress: PropTypes.func.isRequired,
    removeAddress: PropTypes.func.isRequired,

    addContact: PropTypes.func.isRequired,
    removeContact: PropTypes.func.isRequired,

    addTag: PropTypes.func.isRequired,
    removeTag: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    dispatch: PropTypes.func.isRequired,

    onRequestClose: PropTypes.func,
    // onSaved: PropTypes.func,
    dialogs: PropTypes.object.isRequired,
  };

  state = {};

  componentWillMount() {
    this.props.fetchEmployees();

    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customer && nextProps.customer.logo) {
      firebaseStorage.ref(getTenantPath(`/customers/${nextProps.customer.logo}`)).getDownloadURL().then((logo) => {
          this.setState({
            logo,
          });
        }
      );
    }
  }

  // showCustomer = (customerId) => {
  //   this.props.setCustomer({});
  //   this.props.fetchCustomer(customerId);
  //   this.props.fetchEmployees();
  //   this.props.showDialog('customer');
  // };

  handleShowAddress = (address) => {
    this.props.showDialog('address', {
      address,
      onRequestClose: (addr) => {
        this.props.hideDialog('address');
        if (addr) {
          this.props.addAddress(this.props.customer, addr);
        }
      },
    });
  };

  handleShowContact = (contact) => {
    this.props.showDialog('contact', {
      contact,
      onRequestClose: (ctct) => {
        this.props.hideDialog('contact');
        if (ctct) {
          this.props.addContact(this.props.customer, ctct);
        }
      },
    });
  };

  handleShowTag = () => {
    this.props.showDialog('tag', {
      onRequestClose: (tag) => {
        this.props.hideDialog('tag');
        if (tag) {
          this.props.addTag(this.props.customer, tag);
        }
      },
    });
  };

  // handleRequestAddTag = () => {
  //   this.props.showDialog('tag', true);
  // };
  //
  // handleRequestCloseTag = (tag) => {
  //   this.props.hideDialog('tag');
  //   if (tag) {
  //     this.props.addTag(this.props.customer, tag);
  //   }
  // };

  handleRequestRemoveTag(tag) {
    this.props.removeTag(this.props.customer, tag);
  }

  handleLogoUpload = (logo, data) => {
    console.log('handleLogoUpload', logo, data);
    this.setState({
      uploading: true,
    }, () => {
      FireBaseTools.uploadCustomerImage(logo, data)
        .then(() => {
          this.props.setLogo(this.props.customer, logo);
          this.setState({
            uploading: false,
          });
        })
        .catch((err) => {
          console.error('Unable to upload image', err);
          this.props.showError('Unable to upload image');
          this.setState({
            uploading: false,
          });
        });
    });
  };

  handleRemoveAddress = (customer, address) => {
    const context = {
      type: 'warning',
      title: 'Remove Address?',
      message: 'Are you sure you wish to remove this address?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.removeAddress(customer, address);
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleRemoveContact = (customer, contact) => {
    const context = {
      type: 'warning',
      title: 'Remove Contact?',
      message: 'Are you sure you wish to remove this contact?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.removeContact(customer, contact);
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  renderOverview(customer, editable) {
    return (<div>
      <div style={commonStyles.row}>
        <div>
          <Field
            name="name"
            component={TextField}
            floatingLabelText="Name"
            floatingLabelFixed
            fullWidth
            style={commonStyles.input}
            readOnly={!editable}
          />
          {/*<Field*/}
          {/*name="customerManagerId"*/}
          {/*style={commonStyles.input}*/}
          {/*component={AutoComplete}*/}
          {/*floatingLabelText="Customer Manager"*/}
          {/*floatingLabelFixed*/}
          {/*openOnFocus*/}
          {/*filter={customizedFuzzyFilter}*/}
          {/*dataSource={editable ? this.props.employees : []}*/}
          {/*dataSourceConfig={dataSourceConfig}*/}
          {/*fullWidth*/}
          {/*readOnly={!editable}*/}
          {/*/>*/}
          <Field
            name="customerManagerId"
            style={commonStyles.input}
            component={SelectField}
            floatingLabelText="Customer Manager"
            floatingLabelFixed
            fullWidth
            readOnly={!editable}
          >
            {this.props.employees.map((employee) => {
              return (<MenuItem key={employee.id} value={employee.id} primaryText={employee.name}/>);
            })}
          </Field>

          <div style={styles.tagsHeader}>
            <label style={styles.tagsLabel}>Tags</label>
            {editable ? <FloatingActionButton
              style={styles.addTag}
              onClick={this.handleShowTag}
              mini
              secondary
            >
              <ContentAdd/>
            </FloatingActionButton> : null}
          </div>
          {this.renderTags(customer.tags, editable)}
        </div>
        <div style={commonStyles.input}>
          {editable ? <ImageUpload
            type="customer"
            src={this.state.logo}
            height={300}
            width={300}
            onUpload={this.handleLogoUpload}/> : <img alt="Staza" src={this.state.logo} height="300" width="300"/>}
        </div>
      </div>
      <div style={commonStyles.row}>
        <Field
          name="notes"
          style={commonStyles.input}
          component={TextField}
          floatingLabelText="Notes"
          floatingLabelFixed
          fullWidth
          rows={3}
          multiLine
          readOnly={!editable}
        />
      </div>
    </div>);
  }

  renderTags(tags = [], editable) {
    return (<div style={commonStyles.row}>
      {tags.map((tag) => this.renderTag(tag, editable))}
    </div>);
  }

  renderTag = (tag, editable) => (<Chip
    key={tag}
    onRequestDelete={editable ? () => this.handleRequestRemoveTag(tag) : null}
    style={styles.chip}
  >{tag}</Chip>);

  render() {
    const { handleSubmit, customer } = _.assign({ customer: {} }, this.props);
    const { editable, uploading } = this.state;

    const actions = editable ? [
      <FlatButton
        label="Cancel"
        onClick={() => handleRequestClose(this.props)}
        disabled={uploading}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.props.dispatch(submit('customer'))}
        disabled={uploading}
      />,
    ] : [<FlatButton
      label="Close"
      primary
      onClick={() => handleRequestClose(this.props)}
    />];

    const contacts = customer.contacts ? toArray(customer.contacts) : [];
    const addresses = customer.addresses ? toArray(customer.addresses) : [];

    return (
      <ReduxDialog
        name="customer"
        title={customer.name || 'Create New Customer'}
        actions={actions}
        onRequestClose={() => handleRequestClose(this.props)}
        bodyStyle={styles.body}
      >
        <Form onSubmit={handleSubmit}>
          <Tabs style={styles.tab}>
            <Tab label="Overview">
              <div style={styles.tabContainer}>
                {this.renderOverview(customer, editable)}
              </div>
            </Tab>
            <Tab label="Contacts">
              <div>
                <ContactsTable
                  contacts={contacts}
                  primaryContactId={customer.primaryContactId}
                  onEdit={editable ? (contact) => this.handleShowContact(contact) : null}
                  onRemove={editable ? (contact) => this.handleRemoveContact(this.props.customer, contact) : null}
                />
                {editable ? <FloatingActionButton style={commonStyles.fab} onClick={() => this.handleShowContact({})}
                                                  secondary>
                  <ContentAdd/>
                </FloatingActionButton> : null}
              </div>
            </Tab>
            <Tab label="Addresses">
              <div>
                <AddressesTable
                  addresses={addresses}
                  onEdit={editable ? (address) => this.handleShowAddress(address) : null}
                  onRemove={editable ? (address) => this.handleRemoveAddress(this.props.customer, address) : null}
                />
                {editable ? <FloatingActionButton style={commonStyles.fab} onClick={() => this.handleShowAddress({})}
                                                  secondary>
                  <ContentAdd/>
                </FloatingActionButton> : null}
              </div>
            </Tab>
          </Tabs>
        </Form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'customer',  // a unique identifier for this form
  validate,
  // enableReinitialize: true,
  // keepDirtyOnReinitialize: true,
  onSubmit: (values, dispatch, props) => {
    const customer = values
      .setIn(['id'], props.customer.id || id())
      .setIn(['addresses'], fromJS(props.customer.addresses || {}))
      .setIn(['contacts'], fromJS(props.customer.contacts || {}))
      .setIn(['tags'], fromJS(props.customer.tags || []))
      .setIn(['logo'], props.customer.logo);
    return dispatch(saveCustomerRoutine.trigger(customer));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    handleRequestClose(props, result.payload.toJS());
  },
})(Customer);

function mapStateToProps(state) {
  return {
    customer: state.get('customers').get('customer').toJS(),
    loading: state.get('customers').get('loading'),
    initialValues: state.get('customers').get('customer').toJS(),
    employees: state.get('employees').get('employees').toJS(), //.sort((a, b) => sortStrings(a.name, b.name)),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCustomer,
    fetchEmployees,

    setCustomer,
    setLogo,

    addContact,
    removeContact,

    addAddress,
    removeAddress,

    addTag,
    removeTag,

    showDialog,
    hideDialog,
    showError,

    // submit,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Customer/index.js